import Vue from "vue";
import App from "./App.vue";
import $ from 'jquery';
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import moment from 'moment';
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'
import 'izitoast/dist/js/iziToast.min.js'
import '@/assets/css/style.css'
import firebase from './firebase/init'
import firebaseapp, { PROJECT_ID, URL_CLOUD_FUNCTIONS } from './firebase/init'
import Axios from "axios";
import { Store } from "vuex";

Vue.config.productionTip = false;
Vue.use(moment as any)
Vue.use(iziToast as any)

export const db = firebase.firestore()
export const storage = firebase.storage()
export const storageRef = firebase.storage().ref()
export const auth = firebase.auth()

let userType = store.state.user.type
let userSubType = store.state.user.subType

function validateRoute(type: string, next: any) {
  const currentType = store.state.user.type || userType
  if (currentType) {
    if (type === currentType) {
      iziToast.destroy()
      next()
    } else {
      iziToast.destroy()
      if (currentType === 'field') {
        if (store.state.user.subType === 'ADMINISTRADOR') {
          next('/dashboard-field')
        } else if (store.state.user.subType === 'FINANZAS') {
          next('/payments-field')
        } else {
          next('/requests-field')
        }
      } else if (currentType === 'admin') {
        next('/dashboard-admin')
      } else {
        next()
      }
    }
  } else {
    next('/login')
  }
}

async function validateUserLoad(uid: string) {
  const adminRef = db.collection('admins').doc(uid)
  const usersRef = db.collection('users').doc(uid)
  try {
    const adminDoc = await adminRef.get()
    const adminData = adminDoc.data()
    if (adminDoc.exists && adminData) {
      userType = 'admin'
      userSubType = adminData.type
      store.state.user.uid = uid
      store.state.user.type = userType
      store.state.user.subType = userSubType
      store.state.user.data = adminData
    } else {
      const userDoc = await usersRef.get()
      const userData = userDoc.data()
      if (userDoc.exists && userData) {
        iziToast.destroy()
        userType = 'field'
        userSubType = userData.type
        store.state.user.uid = uid
        store.state.user.type = userType
        store.state.user.subType = userSubType
        store.state.user.data = userData
      } else {
        if (
          router.currentRoute.path !== '/login' &&
          router.currentRoute.path !== '/signup' &&
          router.currentRoute.path !== '/recoverpassword'
        ) {
          store.state.user.uid = ''
          store.state.user.type = ''
          store.state.user.subType = ''
          store.state.user.data = {}
        }
      }
    }
  } catch (error) {
    console.log(error)
  }
}

let vueApp: any = null

firebase.auth().onAuthStateChanged(async user => {
  if (user) {
    store.state.user.uid = user.uid
    if (Object.keys(store.state.user.data).length === 0) {
      await validateUserLoad(user.uid)
    }

    // Only redirect a persisted session during the initial app bootstrap.
    // After the login view is mounted, Login.vue owns the redirect so both
    // flows cannot navigate at the same time.
    if (!vueApp && router.currentRoute.path === '/login' && store.state.user.type === 'admin') {
      userType = store.state.user.type
      userSubType = store.state.user.subType
      await router.replace('/dashboard-admin').catch(err => err)
    }

    try {
      const url = URL_CLOUD_FUNCTIONS + 'getAllPromotionCodes'
      const res = await Axios.get(url)
      store.state.promotionCodes = res.data.promotionCodes.data
    } catch (error) {
      console.log('Error al obtener cupones: ' + error)
    }
  } else {
    store.state.user.uid = ''
    store.state.user.type = ''
    store.state.user.subType = ''
    store.state.user.data = {}
    userType = ''
    userSubType = ''

    if (router.currentRoute.path !== '/login') {
      router.push('/login').catch(err => err)
    }
  }

  if (!vueApp) {
    vueApp = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})

async function validateUser(uid: string, to: any, next: any) {
  const adminRef = db.collection('admins').doc(uid)
  const usersRef = db.collection('users').doc(uid)

  try {
    const adminDoc = await adminRef.get()
    const adminData = adminDoc.data()
    if (adminDoc.exists && adminData) {
      userType = 'admin'
      userSubType = adminData.type
      store.state.user.uid = uid
      store.state.user.type = userType
      store.state.user.subType = userSubType
      store.state.user.data = adminData
      validateRoute(userType, next)
    } else {
      const userDoc = await usersRef.get()
      const userData = userDoc.data()
      if (userDoc.exists && userData) {
        iziToast.destroy()
        userType = 'field'
        userSubType = userData.type
        store.state.user.uid = uid
        store.state.user.type = userType
        store.state.user.subType = userSubType
        store.state.user.data = userData
        validateRoute(userType, next)
      } else {
        if (
          to.path !== '/login' &&
          to.path !== '/signup' &&
          to.path !== '/recoverpassword'
        ) {
          iziToast.destroy()
          store.state.user.uid = ''
          store.state.user.type = ''
          store.state.user.subType = ''
          store.state.user.data = {}

          next('/login')
        } else {
          next()
        }
      }
    }
  } catch (error) {
    console.log(error)
    next()
  }
}

router.beforeEach(async (to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const authenticatedUid = currentUser?.uid || store.state.user.uid
  const hasAuthenticatedSession = Boolean(
    currentUser || (authenticatedUid && store.state.user.type)
  )
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let type = ''
  to.matched.some(record => {
    if (record.meta.type) {
      type = record.meta.type.toString()
    }
  })

  if (requiresAuth && !hasAuthenticatedSession) {
    next('/login')
  } else if (hasAuthenticatedSession) {
    const effectiveType = store.state.user.type || userType
    if (effectiveType) {
      userType = effectiveType
      userSubType = userSubType || store.state.user.subType
      validateRoute(type, next)
    } else if (authenticatedUid) {
      await validateUser(authenticatedUid, to, next)
    } else {
      next('/login')
    }
  } else {
    next()
  }
})
